module.exports = __webpack_public_path__ + "static/media/mask.440cf7a7.svg";